export const customTheme = {
  fontFamily: 'DM Sans Variable',
  background: '#F3F3F3',
  screen: {
    width: 500,
    padding: 2,
  },
};

export const TEXT_STYLES = {
  storeTitle: {
    fontFamily: customTheme.fontFamily,
    fontSize: 16,
    fontWeight: 500,
    color: '#000000',
  },
  allDayLabel: {
    fontFamily: customTheme.fontFamily,
    fontSize: 14,
    fontWeight: 500,
    color: 'black',
  },
  discountLabel: {
    fontFamily: customTheme.fontFamily,
    fontSize: 16,
    fontWeight: 500,
    color: 'green',
  },
  unavailableLabel: {
    fontFamily: customTheme.fontFamily,
    fontSize: 14,
    fontWeight: 400,
    color: '#FF50DD',
  },
};
export const FONT_COLOR = {
  labelColor: '#667085',
};

export const DISCOUNT_LABEL = {
  color: 'green',
};
